// CB:BEGIN ui-button-component
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'default',
  size = 'default',
  className = '',
  ...props
}) => {
  const baseClasses =
    'inline-flex items-center justify-center rounded-lg font-medium transition-colors ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#123c3b] ' +
    'disabled:opacity-50 disabled:pointer-events-none';

  const variantClasses = {
    default:     'bg-[#123c3b] text-white hover:bg-[#0d2b2a]',
    secondary:   'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50',
    destructive: 'bg-red-600 text-white hover:bg-red-700',
    outline:     'border border-gray-200 bg-transparent text-gray-700 hover:bg-gray-50',
    ghost:       'text-gray-700 hover:bg-gray-100',
    link:        'text-[#123c3b] underline-offset-4 hover:underline',
  };

  const sizeClasses = {
    default: 'h-10 py-2 px-4 text-sm',
    sm:      'h-8  px-3 text-xs',
    lg:      'h-11 px-6 text-sm',
    icon:    'h-10 w-10',
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
// CB:END ui-button-component
